import React from 'react';
import DescriptionIcon from '@mui/icons-material/Description';
import DataObjectIcon from '@mui/icons-material/DataObject';
import ChecklistIcon from '@mui/icons-material/Checklist';
import CodeIcon from '@mui/icons-material/Code';
import ArchitectureIcon from '@mui/icons-material/Architecture';

const getPromptIcon = (type) => {
    switch (type) {
        case "data":
            return <DataObjectIcon sx={{ color: "#32CD32" }} />; // Lime Green
        case "project":
            return <ChecklistIcon sx={{ color: "#FFD700" }} />; // Gold
        case "code":
            return <CodeIcon sx={{ color: "#FF6347" }} />; // Tomato
        case "design":
            return <ArchitectureIcon sx={{ color: "#FF69B4" }} />; // Hot Pink
        case "text":
        default:
            return <DescriptionIcon sx={{ color: "#1E90FF" }} />; // Dodger Blue
    }
};

export default getPromptIcon;